module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-BE":{"logout":"Afmelden","login":"Log in"},"en-BE":{"logout":"Logout","login":"Log in"},"fr-BE":{"logout":"Déconnexion","login":"S\u0027identifier"}}')
  delete Component.options._Ctor
}
